<template>
  <section class="prescription-card">
    <h2 class="section-title">
      <span class="title-accent"></span>
      {{ title }}
    </h2>
    <div class="card-content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrescriptionCard',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.prescription-card {
  background: #ffffff;
  border: 1px solid #e3f1ef;
  border-radius: 32px;
  padding: 28px 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #304744;
}

.title-accent {
  display: inline-block;
  width: 4px;
  height: 24px;
  border-radius: 2px;
  background: #009798;
  flex-shrink: 0;
}

.card-content {
  width: 100%;
}
</style>
